import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { AccountService } from 'app/core/services/account.service';
import { User } from 'app/shared/models/User';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { SharedService } from 'app/shared/services/shared.service';
declare var $: any;
import * as moment from 'moment';
import { LendersModel } from '../../../lenders/models/lenders.model';
import { LendersService } from '../../../lenders/services/lenders.service';
import { CookieService } from 'ngx-cookie-service';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'crm-layout',
    templateUrl: 'layout.component.html',
    styleUrls: ['layout.component.css']
})
export class LayoutComponent {
    isAdmin: boolean = false;
    isLender: boolean = false;
    errors: string[] = [];
    selectedMenu: number;
    user: User;
    companyUserList: CompanyUserModel[];
    managerCompanyUserList: CompanyUserModel[];
    currentDate: string;
    displayedCompany: string;
    lender: LendersModel;

    constructor(
        private authService: MsalService,
        private accountService: AccountService,
        private router: Router,
        private sharedService: SharedService,
        private cookieService: CookieService
    ) {
        if (this.router.url.includes('/dashboard'))
            this.selectedMenu = 1;
        else if (this.router.url.includes('/useraudit') ||
            this.router.url.includes('/useraudit/question'))
            this.selectedMenu = 3;
        else if (this.router.url.includes('/company') ||
            this.router.url.includes('/account/users') ||
            this.router.url.includes('/audit') ||
            this.router.url.includes('/question') ||
            this.router.url.includes('/module'))
            this.selectedMenu = 2;
    }

    ngOnInit() {

        // initialise user once - can be referenced from shared service in nested components
        //this.accountService.initUser().subscribe(
        //    user => {
        //        //console.log(user);
        //        this.sharedService.currentUser.subscribe(user => {
        //            this.user = user;
        //            this.isLender = user.isLender;
        //            if (user.isLender) {
        //                this.lendersService.getLenderForContact(user.id).subscribe(
        //                    lender => {
        //                        this.lender = lender;
        //                    }
        //                )
        //            }
        //            if (!user.isAdmin) {

        //                this.accountService.initCompanyUser().subscribe(
        //                    companyUserList => {
        //                        //console.log(companyUserList);
        //                        this.sharedService.currentCompanyUser.subscribe(companyUser => {
        //                            this.companyUserList = companyUser;
        //                            if (this.companyUserList.length == 0) {
        //                                this.displayedCompany = "Not assigned to a company";
        //                            } else if (this.companyUserList.length > 1) {
        //                                this.displayedCompany = "Multiple companies";
        //                            } else {
        //                                this.displayedCompany = this.companyUserList[0].tradingName || this.companyUserList[0].legalName;
        //                            }
        //                            this.managerCompanyUserList = this.companyUserList.filter(x => x.userTypeId == 2);
        //                        })
        //                    },
        //                    error => this.errors = error.errorList
        //                );

        //            } else {
        //                this.isAdmin = user.isAdmin;
        //                this.displayedCompany = "Comply365 Admin";
        //            }
        //        });
        //    },
        //    error => this.errors = error.errorList
        //);

        this.accountService.getUser().subscribe(
            user => {
                this.user = user;
                this.isAdmin = user.isAdmin;
                this.sharedService.changeCurrentUser(this.user);
                if (!user.isAdmin) {
                    this.accountService.getCompanyUser().subscribe(companyUser => {
                        this.companyUserList = companyUser;
                        this.sharedService.changeCurrentCompanyUser(this.companyUserList);

                        if (this.companyUserList.length == 0) {
                            this.displayedCompany = "Not assigned to a company";
                        } else if (this.companyUserList.length > 1) {
                            this.displayedCompany = "Multiple companies";
                        } else {
                            this.displayedCompany = this.companyUserList[0].tradingName || this.companyUserList[0].legalName;
                        }
                        this.managerCompanyUserList = this.companyUserList.filter(x => x.userTypeId == 2);
                    });
                } else {
                    this.displayedCompany = "Comply365 Admin";
                }
            },
            error => {
                this.errors = error.errorList
                this.authService.logoutRedirect();
            }
        );



        this.currentDate = moment().format("dddd, MMMM Do YYYY");
        var html = document.getElementsByTagName('html')[0];
        html.className = 'has-tab-navigation header-dark js flexbox flexboxlegacy no-touch csstransforms csstransforms3d no-overflowscrolling webkit chrome win js no-mobile-device custom-scroll';

        //this._script.loadScripts('body', [
        //    "/assets/js/theme.js",
        //    "/assets/js/custom.js",
        //    "/assets/js/theme.init.js",
        //], true).then(result => { });
    }

    async logOut() {
        //this._authenticationService.logOut();
        //this.router.navigate(['auth/login']);
        //this.cookieService.delete('c365-filters');
        this.authService.logoutRedirect();
    }
}
